"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castell-arquato": {
    "9f44dff3": [{
      "hkey": "822574ac",
      "slug": "bacedasco-alto",
      "name": "Bacedasco Alto",
      "primary": true,
      "skipSearch": false
    }],
    "bacedasco": [{
      "hkey": "822574ac",
      "slug": "bacedasco-alto",
      "name": "Bacedasco Alto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "20e2f662": [{
      "hkey": "909c9d2e",
      "slug": "san-lorenzo",
      "name": "San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo-vigolo-marchese": [{
      "hkey": "909c9d2e",
      "slug": "san-lorenzo",
      "name": "San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;